export var Mitigant;
(function (Mitigant) {
    Mitigant["ApplicationReflectsChanges"] = "APPLICATION_REFLECTS_CHANGES";
    Mitigant["CoApplicantsIncome"] = "CO_APPLICANTS_INCOME";
    Mitigant["ReduceExpenditure"] = "REDUCING_EXPENDITURE";
    Mitigant["SaleOfAssets"] = "SALE_OF_ASSETS";
    Mitigant["SecuringAdditionalIncome"] = "SECURING_ADDITIONAL_INCOME";
    Mitigant["UsingSavings"] = "USING_SAVINGS";
    Mitigant["Other"] = "OTHER";
})(Mitigant || (Mitigant = {}));
//# sourceMappingURL=Mitigant.js.map